import { Component } from '@verndale/core';
class SearchBar extends Component {
  searchIcon: HTMLElement | null;
  closeIcon: HTMLElement | null;

  constructor(el: HTMLElement) {
    super(el);
    this.searchIcon = null!;
    this.closeIcon = null!;
  }
  setupDefaults() {
    this.searchIcon = document.getElementById('search-bar__search-icon');
    this.closeIcon = document.getElementById('search-bar__close-icon');
  }

  addListeners() {
    if (!this.searchIcon) {
      throw new Error('Search icon not found');
    }
    this.searchIcon.addEventListener('click', this.handleClick.bind(this));

    if (!this.closeIcon) {
      throw new Error('Close icon not found');
    }
    this.closeIcon.addEventListener('click', this.handleClick.bind(this));

    document.addEventListener('keydown', this.handleEscKey.bind(this));
    document.addEventListener('mousedown', this.handleClickOutside.bind(this));
  }

  handleClick() {
    const panel = document.getElementById('search-bar__panel');
    if (!panel) {
      throw new Error('Search panel not found');
    }
    panel.classList.toggle('open');

    // Focus the input field when panel is opened
    if (panel.classList.contains('open')) {
      const input = panel.querySelector('input[type="search"]') as HTMLInputElement | null;
      if (input) {
        input.focus();
      }
    }
  }

  handleClickOutside(event: MouseEvent) {
    if (event.target instanceof HTMLElement && !this.el.contains(event.target)) {
      const panel = document.getElementById('search-bar__panel');
      if (panel?.classList.contains('open')) {
        panel.classList.remove('open');
      }
    }
  }

  handleEscKey(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      const panel = document.getElementById('search-bar__panel');
      if (panel?.classList.contains('open')) {
        panel.classList.remove('open');
      }
    }
  }
}

export default SearchBar;
